function yearMonthDayToDate(dateStr, timeAlignment = "start") {
    const utcDateString = dateStr + (timeAlignment === "start" ? "T00:00:00Z" : "T23:59:59Z");
    return new Date(utcDateString);
}
function dateToYearMonthDay(date, timezoneConvert = false) {
    if (timezoneConvert) {
        date = new Date(date.toISOString());
    }
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year.toString()}-${month}-${day}`;
}

export { dateToYearMonthDay, yearMonthDayToDate };
//# sourceMappingURL=date.js.map
